export const defaultCategorySettings = {
    "cut-flower": {
        availableToRetail: false,
        availableToCoops: true,
        availableToWholesale: true,
        retailMarkup: 15,
    },
    "dried-flower": {
        availableToRetail: false,
        availableToCoops: false,
        availableToWholesale: true,
        retailMarkup: 15,
    },
    bucket: {
        availableToRetail: false,
        availableToCoops: false,
        availableToWholesale: true,
        retailMarkup: 15,
    },
    bouquet: {
        availableToRetail: false,
        availableToCoops: false,
        availableToWholesale: true,
        retailMarkup: 15,
    },
    csa: {
        availableToRetail: true,
        availableToCoops: false,
        availableToWholesale: false,
        retailMarkup: 0, // CSA's generally don't have a retail markup
    },
    wreath: {
        availableToRetail: false,
        availableToCoops: false,
        availableToWholesale: true,
        retailMarkup: 15,
    },
    "potted-plant": {
        availableToRetail: false,
        availableToCoops: false,
        availableToWholesale: true,
        retailMarkup: 15,
    },
};
//# sourceMappingURL=category-settings.js.map